export default __webpack_public_path__ + "static/media/thumb-NDNU-5.bbd10085.png";